/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Object for holding Closed Captions settings
 */
export class CCSettingsVO implements ICCSettingsVO {

	/**
	 * @description Closed Captions language persistence between sessions. Values: undefined / language code
	 * @type {String}
	 * @default undefined
	 */
	language: string = undefined;

	/**
	 * @description Closed Captions background color: Values: #FF00FE, #01FFFF, #FFFFFF, #000000, #FFFF01, #FE0000, #0000FE, #00FF00
	 * @type {String}
	 * @default '#000000'
	 */
	bgColor: string = '#000000';

	/**
	 * @description Closed Captions background opacity. Values: 0.05 - 0.25 - 0.5 - 0.75 - 1
	 * @type {Number}
	 * @default 0.75
	 */
	bgOpacity: number = 1;

	/**
	 * @description Closed Captions display style. Values: 'serial', 'scrolling'
	 * @type {String}
	 * @default 'serial'
	 */
	displayStyle: string = 'serial';

	/**
	 * @description Closed Captions Font color. Values: #FF00FE, #01FFFF, #FFFFFF, #000000, #FFFF01, #FE0000, #0000FE, #00FF00
	 * @type {String}
	 * @default '#FFFFFF'
	 */
	fontColor: string = '#FFFFFF';

	/**
	 * @description Closed Captions Font face [Desktop]
	 * @type {String}
	 * @default 'Arial'
	 */
	fontFace: string = 'Arial';

	/**
	 * @description Closed Captions Font family [Chromecast]
	 * @type {String}
	 * @default 'Arial'
	 */
	fontFaceCast: string = 'Droid Sans Mono';

	/**
	 * @description Closed Captions Font opacity. Values: 0.05 - 0.25 - 0.5 - 0.75 - 1
	 * @type {Number}
	 * @default 1
	 */
	fontOpacity: number = 1;

	/**
	 * @description Closed Captions Font size
	 * @type {String}
	 * @default '100%'
	 */
	fontSize: string = '100%';

	/**
	 * @description Closed Captions text edge style. Values: 'none', 'dropShadow', 'raised', 'depressed', 'uniform'
	 * @type {String}
	 * @default 'none'
	 */
	edgeStyle: string = 'text-shadow:none';

	/**
	 * @description Closed Captions text font style (weight). Values: 'normal', 'shadow', 'bold'
	 * @type {String}
	 * @default 'normal'
	 */
	fontStyle: string = 'normal';

	/**
	 * @description Closed Captions position. Values: 'centered', 'dynamic'
	 * @type {String}
	 * @default 'centered'
	 */
	ccPosition: string = 'centered';

	/**
	 * @description Closed Captions animation. Values: 'none', 'scroll'
	 * @type {String}
	 * @default 'none'
	 */
	ccAnimation: string = 'none';

}